import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { philoData } from 'src/components/template/compare/components/data/philoData'

export default (props) => <CompareTemplate location={props.location} data={philoData} />
